const LoginClient = {
  token: "token",
  region: "region",
  sessionTakeover: "/session/takeover",
};

export default LoginClient;
